import { FunctionComponent } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import { Button, Stack, Typography, useTheme } from '@monorepo/nova-ui';

interface Props {
  onClose: () => void;
}

export const WithdrawalConfirmedStage: FunctionComponent<Props> = ({
  onClose,
}) => {
  const theme = useTheme();
  const { t } = useTranslation(['withdrawFundsNova']);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Stack
      gap={isMobile ? theme.spacing(6.5) : theme.spacing(10.5)}
      alignItems={'center'}
      textAlign={'center'}
    >
      <Stack gap={theme.spacing(6)} alignItems={'center'}>
        <Typography variant={'h3'}>
          {t('withdrawFundsNova:success_modal.title')}
        </Typography>
        <SystemIcon
          iconName={'ClockRevert'}
          size={65}
          sx={{
            '& path': {
              fill: `${theme.palette.primary.main} !important`,
              stroke: `${theme.palette.text.opposite} !important`,
            },
          }}
        />
        <Stack>
          <Typography variant={'body1'}>
            {t('withdrawFundsNova:success_modal.message_line1')}
          </Typography>
          <Typography
            variant={'body1'}
            component="div"
            sx={{
              '& strong': {
                fontWeight: theme.typography.fontWeightMedium,
              },
            }}
          >
            <Trans
              ns="withdrawFundsNova"
              i18nKey="success_modal.message_line2"
              components={{ strong: <strong /> }}
            />
          </Typography>
          <Typography variant={'body1'}>
            {t('withdrawFundsNova:success_modal.message_line3')}
          </Typography>
        </Stack>
      </Stack>
      <Button
        variant="primary"
        onClick={onClose}
        sx={{ width: '100%' }}
        size={'lg'}
      >
        {t('withdrawFundsNova:success_modal.back_to_dashboard')}
      </Button>
    </Stack>
  );
};
